import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ContractorService } from 'src/app/Service/Contractor/Contractor.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';


@Component({
  selector: 'app-ContractorAdd',
  templateUrl: './ContractorAdd.component.html',
  styleUrls: ['./ContractorAdd.component.scss']
})
export class ContractorAddComponent implements OnInit {

  constructor(
    private Contractor_Service:ContractorService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewContractor=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(1118).subscribe(
      data=>{
        
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewContractor:FormGroup;

  get_Form_Title(){
    return this.AddNewContractor.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewContractor(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    this.InProccessing=true
    this.Contractor_Service.AddContractor(Record).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
        }
        else{
          this.AddNewContractor.reset()
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
        
      }
    )
  }
}
